import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import variables from "../variables";

const {addClass, removeClass, get, toggleClass} = $dom

const groupSelector = '.js-cart-control-group'
const buttonSelector = '.js-cart-control-button'
const likeSelector = '.js-cart-like-button'

const likeActive = 'cart__like-active'

export default function () {
    const checkMinusButton = (label, button) => {
        if (label.textContent === '1') {
            button.dataset.action = 'delete'
            addClass(button, 'hidden')
            removeClass(button.previousElementSibling, 'hidden')
        } else {
            removeClass(button, 'hidden')
            addClass(button.previousElementSibling, 'hidden')
            button.dataset.action = 'minus'
        }
    }

    const handleClickAdd = e => {
        if (e.target.dataset.action === 'add') {
            removeClass(e.target.nextElementSibling, variables.classNames.hidden)
            addClass(e.target, variables.classNames.hidden)
        } else if (e.target.dataset.action === 'plus') {
            const label = e.target.previousElementSibling
            label.textContent = (Number(label.textContent) + 1).toString()

            checkMinusButton(e.target.previousElementSibling, e.target.previousElementSibling.previousElementSibling)
        } else if (e.target.dataset.action === 'minus') {
            const label = e.target.nextElementSibling
            label.textContent = (Number(label.textContent) - 1).toString()

            checkMinusButton(e.target.nextElementSibling, e.target)
        } else if (e.target.dataset.action === 'delete') {
            const addButton = get(buttonSelector, e.target.closest('.js-cart-control-group'))
            removeClass(addButton, variables.classNames.hidden)
            addClass(addButton.nextElementSibling, variables.classNames.hidden)
        }
    }

    const handleClickLike = (e) => {
        toggleClass(e.target, likeActive)
    }

    return new Component({
        name: 'cartControl',
        requiredTargets: [groupSelector, buttonSelector],
        onInit() {
            console.log('Работает...')
            $events.delegate
                .on('click', buttonSelector, handleClickAdd)
                .on('click', likeSelector, handleClickLike)
        },
        onDestroy() {
            $events.delegate
                .off('click', buttonSelector, handleClickAdd)
                .off('click', likeSelector, handleClickLike)
        },
    })

}